import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Public as PublicIcon } from '@mui/icons-material';
import { useTabsNavigationStore, APP_VIEWS } from '../../../stores';
import { GlobeIcon, ChevronDownIcon } from '../model/icons';

// .season-pick — выбор сезона (dropdown). Выбор сезона возвращает к сменам.
export default function SeasonPicker({ seasons }) {
    const selectedSeason = useTabsNavigationStore(state => state.selectedSeason);
    const setSeason = useTabsNavigationStore(state => state.setSeason);
    const showShifts = useTabsNavigationStore(state => state.showShifts);
    const currentView = useTabsNavigationStore(state => state.currentView);

    const [anchor, setAnchor] = useState(null);

    const handleSelect = (season) => {
        setSeason(season);
        if (currentView !== APP_VIEWS.SHIFTS) showShifts();
        setAnchor(null);
    };

    return (
        <>
            <button type="button" className="season-pick" onClick={(e) => setAnchor(e.currentTarget)}>
                <span className="gl"><GlobeIcon /></span>
                <span>{selectedSeason || 'Выберите сезон'}</span>
                <ChevronDownIcon />
            </button>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
                {seasons.map(season => (
                    <MenuItem
                        key={season}
                        onClick={() => handleSelect(season)}
                        selected={selectedSeason === season}
                    >
                        <ListItemIcon><PublicIcon fontSize="small" /></ListItemIcon>
                        <ListItemText>{season}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

SeasonPicker.propTypes = {
    seasons: PropTypes.arrayOf(PropTypes.string).isRequired
};
